import * as React from 'react';
import { camelCase } from 'lodash';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import { getDisplayDate } from 'utils/date';
import { DELIVERABLE_ICONS } from 'utils/deliverables';

type Event = {
  date: string,
  description: string,
  title?: string,
  tasksChanges: {
    [x: string]: number
  },
  historyType: string
};

type Props = {
  events: Array<Event>
};

const getTooltip = (
  tasksChanges: {
    [x: string]: number
  }
): JSX.Element => (
  <div className="vertical-timeline__tasks-info">
    {
      Object.keys(tasksChanges).map(taskType => (
        <div className="vertical-timeline__task-info" key={taskType}>
          <SVGDynamicIcon
            name={`${DELIVERABLE_ICONS[camelCase(taskType)]}`}
            width={16}
            height={16}
          />
          <span className="vertical-timeline__task_count">
            {tasksChanges[taskType]}
          </span>
        </div>
      ))
    }
  </div>
);

const VerticalTimeline = (
  {
    events
  }: Props
): JSX.Element => (
  <div className="vertical-timeline">
    {
      events.map((event, index) => (
        <React.Fragment key={`vertical-timeline-event-${index}`}>
          <div className="vertical-timeline__date">
            {getDisplayDate(event.date)}
          </div>
          <div className="vertical-timeline__description">
            {
              event.title && (
                <span className="vertical-timeline__label">{event.title}{event.description ? ':' : ''}&nbsp;</span>
              )
            }
            <span>{event.description}</span>
            { event.historyType === 'requirement_change' && (
              <Tooltip
                component={getTooltip(event.tasksChanges)}
                width="auto-compact"
              >
                <span className="vertical-timeline__info">
                  <SVGDynamicIcon
                    name="info-inside-circle-custom-bg-white-fg"
                    width={16}
                    height={16}
                    customColor="black"
                  />
                </span>
              </Tooltip>
            )}
          </div>
        </React.Fragment>
      ))
    }
  </div>
);

export default VerticalTimeline;
